import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import config  from './aws-exports';
import './assets/fonts/fonts.css';
import { ThemeProvider, createTheme } from '@aws-amplify/ui-react';



Amplify.configure(config);

// Define custom theme
const theme = createTheme({
  name: 'custom-theme',
  tokens: {
    fonts: {
      default: { value: 'ContentFont, sans-serif' }, // Define your default font
      defaultVariable: { value: 'ContentFont, sans-serif' }, // Variable for font-variation-settings support
    },
    colors: {
      brand: {
        primary: { value: '#3AB1AA' }, // Replace with your desired color
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <ThemeProvider theme={theme}>
    <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
